module.exports = __webpack_public_path__ + "img/2.be703a54.svg";